jQuery(function ($) {
  var commentform = $('#commentform');
  commentform.prepend('<div id="comment-status" ></div>'); // add info panel before the form to provide feedback or errors

  var statusdiv = $('#comment-status'); // define the infopanel

  commentform.submit(function(){
    //serialize and store form data in a variable
    var formdata = commentform.serialize();
    //Add a status message
    statusdiv.html('<p>Enviando mensaje...</p>');
    //Extract action URL from commentform
    var formurl = commentform.attr('action');
    //Post Form with data

    $(commentform).find(".form-floating").hide();
    $(commentform).find(".form-submit").hide();    

    $.ajax({
      type: 'post',
      url: formurl,
      data: formdata,
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        statusdiv.html('<p class="ajax-error" >Ocurrió un error al enviar el mensaje</p>');
      },
      success: function(data, textStatus) {
        if(data == "success" || textStatus == "success") {
          statusdiv.html('<p class="ajax-success" >Tu mensaje ha sido enviado con éxito.<br />¡Gracias por compartir tu opinión con nosotros!</p>');
        } else {
          statusdiv.html('<p class="ajax-error" >Ocurrió un error al enviar el mensaje</p>');
          commentform.find('textarea[name=comment]').val('');
			    $(commentform).find(".form-floating").show();
			    $(commentform).find(".form-submit").show();    
        }
      }
    });
    return false;
  });
});